import { render } from "./Montant.vue?vue&type=template&id=0bbc7c5e"
import script from "./Montant.vue?vue&type=script&lang=js"
export * from "./Montant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__